import React from 'react';
import { Paragraph, InlineLink } from '../../Typography';
import { TimelineIcon, TimelineText, TimelineContent, StyledSmoothAnchor } from './elements';

/**
 * @type React.FunctionComponent<{ title: string, CTA?: string, right?: boolean}>
 */

const TimelineItem = ({ title, CTAForm, CTAScroll, icon, right, fromFormationsPage }) => {
  const selectedCertification = fromFormationsPage ? fromFormationsPage.certification : null;
  const selectedFormation = fromFormationsPage ? fromFormationsPage.type : null;
  return (
    <TimelineContent right={right}>
      <TimelineIcon>{icon}</TimelineIcon>

      <TimelineText>
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Paragraph
            css={{
              fontWeight: 'bold',
              fontSize: 17,
              lineHeight: '22px',
              padding: 0,
              textAlign: 'center',
            }}
          >
            {title}
          </Paragraph>
          {CTAForm && (
            <InlineLink
              to="/postuler/"
              state={{
                fromFormationsPage: {
                  certification: selectedCertification,
                  type: selectedFormation,
                  date: null,
                },
              }}
              css={{
                fontSize: 17,
                lineHeight: '22px',
                paddingLeft: 5,
              }}
            >
              {CTAForm}
            </InlineLink>
          )}
          {CTAScroll && (
            <StyledSmoothAnchor offset="100" href="#event-section">
              {' '}
              {CTAScroll}
            </StyledSmoothAnchor>
          )}
        </div>
      </TimelineText>
    </TimelineContent>
  );
};

export default TimelineItem;
